/**
 * @author Fernando FH
 */

import ServiceConstant from "@/app/core/ServiceConstant";
import MainService from "@/app/services/MainService";
import ServicePath from "@/core/ServicePath";

export default class TelemedicinePendingService extends MainService {

  static listAllPagination(params) {
    return this.postSEC(ServiceConstant.TELEMEDICINE_LISTALL_PAGINATION, params);
  }
  
   static get(params) {
    return this.postSEC(ServiceConstant.TELEMEDICINE_GET, params);
  }
  
  /* static add(params) {
    return this.postSEC(ServiceConstant.COLPOSCOPY_ADD, params);
  }
  
  static pdf(params) {
    return this.postPDFSEC(ServicePath.COLPOSCOPY_PDF, params);
  }  */

}
